import { EnvironmentOutlined } from "@ant-design/icons";
import { Card, Col, Row, Space, Typography, theme } from "antd";
import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import LoginForm from "../components/Auth/LoginForm";
import LogoExcelia from "../components/Layout/LogoExcelia";
import { useAuth } from "../contexts/AuthContext";
import { getActiveEnvironment, initializeEnvironmentTable } from "../services/environmentService";
import packageJson from "../../package.json";

const { Title, Text } = Typography;

const LoginPage = () => {
  const { token } = theme.useToken();
  const { isAuthenticated, loading } = useAuth();
  const [currentEnvironment, setCurrentEnvironment] = useState(null);

  useEffect(() => {
    loadEnvironmentInfo();
  }, []);

  const loadEnvironmentInfo = async () => {
    try {
      // Inicializar la tabla de entorno primero
      await initializeEnvironmentTable();
      const env = await getActiveEnvironment();
      setCurrentEnvironment(env);
    } catch (error) {
      console.error("Error cargando información del entorno:", error);
    }
  };

  // Si ya está autenticado, redirigir al inicio
  if (!loading && isAuthenticated()) {
    return <Navigate to="/" />;
  }

  return (
    <div style={{ padding: "24px", minHeight: "100vh", backgroundColor: token.colorBgLayout }}>
      <Row justify="center" align="middle" style={{ minHeight: "100vh" }}>
        <Col xs={24} sm={20} md={16} lg={12} xl={8}>
          <Space direction="vertical" size="large" style={{ width: "100%" }}>
            <div style={{ textAlign: "center" }}>
              {/* El isotipo, encima del saludo y no a su lado.
                  «Bienvenido a ExceliaOne» es una frase, no una marca, y un
                  logotipo pegado a la izquierda de una frase se lee raro.
                  Aquí pesa más que en el resto: esta pantalla no tiene barra
                  lateral ni cabecera --sólo se dibujan con sesión iniciada--,
                  así que era la única de la aplicación sin un solo logotipo, y
                  es la primera que se ve cada día.
                  Toma `currentColor`, así que sale oscuro sobre el fondo claro
                  y claro en tema oscuro, sin dos versiones del archivo. */}
              <LogoExcelia size={40} style={{ margin: "0 auto 16px" }} />
              <Title level={2} style={{ marginTop: 0 }}>
                Bienvenido a ExceliaOne
              </Title>
              <Text type="secondary">Sistema de gestión empresarial</Text>
            </div>

            {currentEnvironment && (
              <Card
                size="small"
                style={{
                  // Verde del tema y no fijo: la tarjeta ponía `#f6ffed`, pero
                  // el nombre de la empresa y el del entorno toman su color del
                  // tema. En oscuro quedaban blancos sobre verde claro, en la
                  // primera pantalla que se ve cada día.
                  backgroundColor: token.colorSuccessBg,
                  borderColor: token.colorSuccessBorder,
                  textAlign: "center",
                }}
              >
                <Space direction="vertical" size="small">
                  <Space>
                    <EnvironmentOutlined style={{ color: "#52c41a" }} />
                    <Text strong style={{ color: "#52c41a" }}>
                      Entorno Actual
                    </Text>
                  </Space>
                  <div>
                    <Text strong>{currentEnvironment.company}</Text>
                    <br />
                    <Text type="secondary" style={{ fontSize: "12px" }}>
                      {currentEnvironment.env}
                    </Text>
                  </div>
                </Space>
              </Card>
            )}

            <LoginForm />

            <div style={{ textAlign: "center" }}>
              <Text type="secondary" style={{ fontSize: "12px" }}>
                Versión {packageJson.version} - Sistema de sincronización avanzado
              </Text>
            </div>
          </Space>
        </Col>
      </Row>
    </div>
  );
};

export default LoginPage;
